var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "4743fc603c1bbd2f40aa785bf6f9a67d.png",
    width: 700,
    height: 679
});